module.exports = __webpack_public_path__ + "static/media/CZ.03e944b8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svgs/flags/CZ.svg
// module id = 236
// module chunks = 0